import styled from 'styled-components';
import {getSpacing, getToken} from '@tickchak/react-share/app';
import {STRONG_BLUE} from '../../../../globalVariables/GlobalVariables';

export const inlineContentEditable = styled.div<{$isEmpty?: boolean}>`
    outline: none;
    position: relative;
    padding: ${getSpacing('spaceXs')};
    padding-inline-end: ${getSpacing('spaceLg')};
    
    &[data-is-empty='true'] {
        color: ${getToken('color.state.warning.main')};
        font-weight: bold;
    }
    
    .variable {
        font-weight: bold;
        color: ${STRONG_BLUE};
    }
`;
